export default function CivilServiceMtgEvent01() {
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button className="accordion-button caret-off collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseCivilServiceMeeting">
          <div className="custom-button-layout">
            <img className="day-icon" src="../img/cal-icons/october-14-icon.png" alt="October 14 Calendar Icon" />
            <b>Civil Service Commission Meeting</b>
            {/*  <span className="badge bg-danger">CANCELED</span>  */}
            <span className="badge bg-primary badge-custom">Meeting</span>
          </div>
        </button>
      </h2>
      <div id="collapseCivilServiceMeeting" className="accordion-collapse collapse" data-bs-parent="#upcomingEventsAccordion">
        <div className="accordion-body">
          <p>
            Wednesday, October 14, 2026 at 6:30 p.m.
            <br />
            <a href="https://maps.app.goo.gl/uB7NMgLow9j2wTka6">
              <i className="fa-solid fa-location-pin"></i>&nbsp;Morrisville Borough Hall (35 Union St.)
            </a>
          </p>

{/*
          <p>
            <a href="../docs/notice/notice-2026-CSC-Agenda-Aug-11.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp;Meeting Agenda
            </a>
          </p>
          

          
          <p>
            Notice is hereby given that the Borough of Morrisville Civil Service Commission will convene a Public Meeting on Monday, September 21, 2026, 
            at Borough Hall, 35 Union Street, Morrisville, PA, beginning at 6:00 p.m. The purpose of the meeting is to certify an Eligibility List for 
            full-time police officers and to conduct any other business that may properly come before the Commission in accordance with the Rules and 
            Regulations of the Commission. Any person with a disability requiring a special accommodation desiring to attend the meeting 
            should call 215.295.8181 as early as possible prior to the meeting. The municipality will make every effort to provide reasonable accommodations. 
            <br />
            Gregory R. Heleniak,
            <br />
            Solicitor,
            <br />
            Morrisville Civil Service Commission
          </p>
          */}
        </div>
      </div>
    </div>
  );
}
